import { Injectable } from "@angular/core";
import { Api } from "../api/api";
import { Storage } from "@ionic/storage";
import { LoadingController } from "ionic-angular";

import { MasterData } from "../../models/master-data";

@Injectable()
export class MasterDataProvider {
  private url: string = "types";
  private key: string = "pv-master-data";

  constructor(
    public api: Api,
    public storage: Storage,
    public loadingCtrl: LoadingController
  ) {}

  async asyncData() {
    const data = await this.storage.get(this.key);
    let showLoading = false;
    if (data) {
      console.log("+++++sync data");
      console.log(data);
      MasterData.setData(data);
      showLoading = false;
      this.fetchAll(showLoading);
    } else {
      await this.fetchAll(showLoading);
    }
  }

  syncData(): void {
    this.storage.get(this.key).then(data => {
      let showLoading = false;
      if (data) {
        console.log("+++++sync data");
        console.log(data);
        MasterData.setData(data);
        showLoading = false;
      }
      this.fetchAll(showLoading);
    });
  }

  fetchAll(showLoading: boolean): void {
    let loading = this.loadingCtrl.create();
    if (showLoading) {
      loading.present();
    }

    this.api.get(this.url).subscribe(
      (data: any) => {
        MasterData.setData(data);
        this.storage.set(this.key, data);
      },
      error => {},
      () => {
        loading.dismiss();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/master-data/master-data.ts